import { ENV_STORAGE_SUFFIX } from '../constants/apis'

export type FavoriteOrgId = string | number

const SHOW_ONLY_SUFFIX = ':showOnly'

function makeKey(email?: string | null): string {
  return `favoriteOrgs:${email || 'global'}${ENV_STORAGE_SUFFIX}`
}

function makeShowOnlyKey(email?: string | null): string {
  return `${makeKey(email)}${SHOW_ONLY_SUFFIX}`
}

export const favoriteOrgsStorage = {
  get(email?: string | null): FavoriteOrgId[] {
    try {
      const raw = localStorage.getItem(makeKey(email))
      if (!raw) {
        return []
      }
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? (parsed as FavoriteOrgId[]) : []
    } catch (e) {
      console.error(`[favoriteOrgsStorage] Failed to get favorites`, e)
      return []
    }
  },

  set(ids: FavoriteOrgId[], email?: string | null): void {
    try {
      localStorage.setItem(makeKey(email), JSON.stringify(ids))
    } catch (e) {
      console.error(`[favoriteOrgsStorage] Failed to set favorites`, e)
    }
  },

  toggle(id: FavoriteOrgId, email?: string | null): FavoriteOrgId[] {
    const current = favoriteOrgsStorage.get(email)
    const exists = current.some(existing => String(existing) === String(id))
    const next = exists
      ? current.filter(existing => String(existing) !== String(id))
      : [...current, id]
    favoriteOrgsStorage.set(next, email)
    return next
  },

  getShowOnly(email?: string | null): boolean {
    try {
      return localStorage.getItem(makeShowOnlyKey(email)) === 'true'
    } catch (e) {
      console.error(`[favoriteOrgsStorage] Failed to get showOnly`, e)
      return false
    }
  },

  setShowOnly(value: boolean, email?: string | null): void {
    try {
      localStorage.setItem(makeShowOnlyKey(email), value ? 'true' : 'false')
    } catch (e) {
      console.error(`[favoriteOrgsStorage] Failed to set showOnly`, e)
    }
  }
}
